import {
    PageBuilderContainerPropertiesModel,
    PageBuilderWidgetModel
} from "@de-trustleap/shared-models";
import { createElementFromWidget } from "../render/createElementFromWidget";
import { processBackgroundColor } from "../utils/processBackgroundColor";

export class ContainerWidget {
    private properties: PageBuilderContainerPropertiesModel;
    private containerChild?: PageBuilderWidgetModel;
    private padding: { top?: number; right?: number; bottom?: number; left?: number };
    private margin: { top?: number; right?: number; bottom?: number; left?: number };
    private backgroundColor: string;

    constructor(
        properties: PageBuilderContainerPropertiesModel,
        containerChild?: PageBuilderWidgetModel,
        padding: { top?: number; right?: number; bottom?: number; left?: number } = {},
        margin: { top?: number; right?: number; bottom?: number; left?: number } = {},
        backgroundColor: string = 'transparent'
    ) {
        this.properties = properties;
        this.containerChild = containerChild;
        this.padding = padding;
        this.margin = margin;
        this.backgroundColor = processBackgroundColor(backgroundColor); // ✅ korrektes Format
    }

    async getWidget(): Promise<HTMLElement> {
        const element = document.createElement('div');

        // Basis-Stile
        Object.assign(element.style, {
            boxSizing: 'border-box',
            display: 'block',
            backgroundColor: this.backgroundColor,
            width: '100%',
            overflow: 'visible',
            whiteSpace: 'normal',
            wordBreak: 'break-word',
        });

        // Padding & Margin setzen
        ['top', 'right', 'bottom', 'left'].forEach((side) => {
            const paddingValue = this.padding?.[side as keyof typeof this.padding] ?? 0;
            const marginValue = this.margin?.[side as keyof typeof this.margin] ?? 0;
            element.style.setProperty(`padding-${side}`, `${paddingValue}px`);
            element.style.setProperty(`margin-${side}`, `${marginValue}px`);
        });

        // Border-Radius
        if (this.properties.borderRadius) {
            element.style.borderRadius = `${this.properties.borderRadius}px`;
        }

        // Box-Shadow
        const shadow = this.properties.shadow;
        if (shadow?.offset) {
            const { x = 0, y = 0 } = shadow.offset;
            const blur = shadow.blurRadius ?? 0;
            const spread = shadow.spreadRadius ?? 0;
            const color = shadow.color ?? '00000000';

            const alpha = parseInt(color.slice(0, 2), 16) / 255;
            const r = parseInt(color.slice(2, 4), 16);
            const g = parseInt(color.slice(4, 6), 16);
            const b = parseInt(color.slice(6, 8), 16);
            element.style.boxShadow = `${x}px ${y}px ${blur}px ${spread}px rgba(${r},${g},${b},${alpha})`;
        }

        // Inhalt einfügen (async!)
        if (this.containerChild) {
            const childElement = await createElementFromWidget(this.containerChild);
            if (childElement) {
                childElement.style.removeProperty('width');
                childElement.style.removeProperty('max-width');
                childElement.style.boxSizing = 'border-box';
                childElement.style.whiteSpace = 'normal';
                childElement.style.wordWrap = 'break-word';
                element.appendChild(childElement);
            }
        }

        return element;
    }
}
